import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			closeButton: {
				color: theme.palette.grey[400],
				display: "flex",
				justifyContent: "flex-end",
				webkitJustifyContent: "flex-end"
			},
			body: {
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				flexWrap: "wrap",
				alignItems: "center"
			},
			title: {
				fontSize: 16,
				fontWeight: 400,
				color: theme.palette.common.black,
				padding: "16px 30px",
				borderBottom: `1px solid ${theme.palette.grey[200]}`
			},
			btnSubmit: {
				color: theme.palette.secondary.main,
				fontSize: 15,
				fontWeight: 400,
				cursor: "pointer",
				"&:hover": {
					color: theme.palette.secondary.dark
				}
			},
			borderRight: {
				borderRight: `1px solid ${theme.palette.grey[800]}`
			}
		}),
	{
		name: "ConfirmOrder",
		index: 1
	}
);

export default useStyles;
